"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserFeedback = void 0;

var _react = _interopRequireDefault(require("react"));

var _question = _interopRequireDefault(require("./question.js"));

var firebase = _interopRequireWildcard(require("firebase"));

var _reactShareButtons = _interopRequireDefault(require("@ta-interaktiv/react-share-buttons"));

require("@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/button.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/table.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/label.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

require('../style/styles.css');

/**
 * User Feedback Documentation
 */
var UserFeedback =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserFeedback, _React$Component);

  function UserFeedback(props) {
    var _this;

    _classCallCheck(this, UserFeedback);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserFeedback).call(this, props));
    _this.state = {
      questionRating: [],
      readyToSubmit: true
    };
    var questionRatingArray = [];

    _this.props.questions.map(function (question) {
      questionRatingArray.push({
        text: question,
        rating: -1
      });
    });

    _this.ratingHandler = _this.ratingHandler.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.writeRatingToDatabase = _this.writeRatingToDatabase.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      questionRating: questionRatingArray // Init Firebase

    };
    var config = {
      apiKey: 'AIzaSyBrzZekcWyfCV4_bDDoHjGkL438BIhpLZA',
      authDomain: 'ta-user-feedback.firebaseapp.com',
      databaseURL: 'https://ta-user-feedback.firebaseio.com',
      storageBucket: 'ta-user-feedback.appspot.com'
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }

    return _this;
  } // Write the data after clicking submit button


  _createClass(UserFeedback, [{
    key: "writeRatingToDatabase",
    value: function writeRatingToDatabase() {
      var _this2 = this;

      this.state.questionRating.map(function (question) {
        var newQuestion = firebase.database().ref('stories/' + _this2.props.articleId + '/questions/' + question.text).push();
        newQuestion.set({
          rating: parseInt(question.rating)
        });

        _this2.getRatingAverage(question.text, question.rating);

        localStorage.setItem('vote-' + _this2.props.articleId, 'voted');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Interactions',
          event_action: 'click',
          event_label: 'region: userVote/' + parseInt(question.rating)
        });
        console.log('saved question: ' + question.text + ' rated with: ' + question.rating + 'stars');
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: 'region: userVoteButtonClicked/'
      });
      console.log(window.dataLayer);
    }
  }, {
    key: "getArticleAverageRating",
    value: function getArticleAverageRating() {
      var averageSum = 0;
      var questionCount = 0;
      this.state.questionRating.map(function (question) {
        averageSum = averageSum + question.average;
        questionCount = questionCount + 1;
      });
      var average = averageSum / questionCount;
      this.setState({
        overallAverage: average
      });
    } // Get question rating data from Firebase

  }, {
    key: "getRatingAverage",
    value: function getRatingAverage(question, rating) {
      var starCountRef = firebase.database().ref('stories/' + this.props.articleId + '/questions/' + question);
      var total = 0;
      var count = 0;
      var countIteration = 0;

      var _self = this;

      starCountRef.once('value', function (snapshot) {
        snapshot.forEach(function (singleValue) {
          total = total + parseInt(singleValue.val().rating);
          countIteration = countIteration + 1;
        });
        count = snapshot.numChildren();
        var average = total / count; // Add average rating to the questionRatingArray in the this.state attribute

        _self.ratingHandler(question, rating, average, count);

        _self.setState({
          votingIsOver: true,
          votes: count,
          votesIteration: countIteration,
          allQuestionsVotes: _self.state.votes + count
        });

        _self.getArticleAverageRating();
      });
    } // Set the state for all questions – with ratings from Question component

  }, {
    key: "ratingHandler",
    value: function ratingHandler(question, rating, average, count) {
      // console.log(question, rating)
      var questionRatingArray = [];
      this.state.questionRating.map(function (localQuestion) {
        if (localQuestion.text === question) {
          // Set the array with new rating from Question component
          questionRatingArray.push({
            text: localQuestion.text,
            rating: parseInt(rating),
            average: average,
            count: count
          });
        } else {
          questionRatingArray.push({
            text: localQuestion.text,
            rating: localQuestion.rating,
            average: localQuestion.average,
            count: localQuestion.count
          });
        }
      });
      this.setState({
        questionRating: questionRatingArray
      });
    }
  }, {
    key: "checkIfSubmitReady",
    value: function checkIfSubmitReady() {
      var submitReady = true;
      this.state.questionRating.map(function (question) {
        if (question.rating < 0) {
          submitReady = false;
        }
      }); // TODO Don't write to state directly

      this.state.readyToSubmit = submitReady;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Check if the user already voted or not. So he can't vote again.
      if (localStorage.getItem('vote-' + this.props.articleId)) {
        this.state.questionRating.map(function (question) {
          _this3.getRatingAverage(question.text, 0);
        });
        this.setState({
          votingIsOver: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      // TODO Don't run these checks in render, especially when they write to
      //  state afterwards
      this.checkIfSubmitReady();
      return _react.default.createElement("div", {
        className: "".concat(this.props.className, " user-feedback")
      }, _react.default.createElement("div", {
        className: "ui vertical ".concat(this.props.backgroundColor.indexOf('#') === 0 ? '' : this.props.backgroundColor, " ").concat(this.props.inverted ? 'inverted' : '', " very fitted segment mobile low padding"),
        style: {
          backgroundColor: this.props.backgroundColor.indexOf('#') === 0 ? this.props.backgroundColor : ''
        }
      }, _react.default.createElement("div", {
        className: "ui stackable grid all-fonts-bentonized"
      }, _react.default.createElement("div", {
        className: "sixteen column title mobile no padding bottom"
      }, this.state.votingIsOver && _react.default.createElement("div", {
        style: {
          color: this.props.fontColor,
          fontFamily: 'Benton Sans Cond, sans-serif !important'
        }
      }, _react.default.createElement("span", {
        style: {
          marginBottom: '0px',
          fontFamily: 'Benton Sans Cond, sans-serif !important'
        }
      }, "Vielen Dank f\xFCr Ihre Bewertung."), _react.default.createElement("span", {
        className: "user sentence",
        style: {
          fontFamily: 'Benton Sans Cond, sans-serif !important'
        }
      }, "\xA0Bisher haben", ' ', _react.default.createElement("p", {
        style: {
          display: 'inline',
          fontFamily: 'Benton Sans Cond',
          fontWeight: 800
        },
        className: "ui tiny ".concat(this.props.starColor, " infographic header")
      }, this.state.votes, " Personen"), ' ', "abgestimmt."), this.state.overallAverage >= 4 && _react.default.createElement("span", null, "\xA0", this.props.answerText)), !this.state.votingIsOver && _react.default.createElement("div", {
        style: {
          color: this.props.fontColor
        }
      }, _react.default.createElement("p", {
        className: "question-title"
      }, _react.default.createElement("strong", null, this.props.title))))), _react.default.createElement("div", {
        className: "ui stackable inverted grid"
      }, _react.default.createElement("div", {
        className: "sixteen wide column"
      }, _react.default.createElement("table", {
        id: "vote-table",
        className: "ui very basic table"
      }, _react.default.createElement("tbody", null, this.state.questionRating.map(function (question, i) {
        return _react.default.createElement(_question.default, {
          theme: _this4.props.theme,
          ratingHandler: _this4.ratingHandler,
          starAmount: _this4.props.starAmount,
          starIcon: _this4.props.starIcon,
          starColor: _this4.props.starColor,
          fontColor: _this4.props.fontColor,
          question: question.text,
          votingIsOver: _this4.state.votingIsOver,
          averageRating: question.average,
          ownRatingStarAmount: question.rating,
          ratingCount: question.count,
          inverted: _this4.props.inverted,
          key: "question-".concat(i)
        });
      })))), _react.default.createElement("div", {
        className: "Aligner sixteen wide center aligned column"
      }, this.state.votingIsOver && _react.default.createElement(_reactShareButtons.default, {
        inverted: this.props.inverted,
        articleId: this.props.articleId,
        displayType: "horizontal icons",
        itemClassName: this.props.starColor,
        className: this.props.starColor,
        iconClassName: this.props.fontColor
      }), !this.state.votingIsOver && _react.default.createElement("button", {
        onClick: this.writeRatingToDatabase,
        className: "ui button ".concat(this.state.readyToSubmit === true ? '' : 'disabled')
      }, "Bewerten")))));
    }
  }]);

  return UserFeedback;
}(_react.default.Component);

exports.UserFeedback = UserFeedback;
UserFeedback.defaultProps = {
  theme: 'simple',
  fontColor: 'black',
  starIcon: 'star',
  starAmount: 5,
  className: '#000',
  inverted: false,
  backgroundColor: '',
  starColor: '#FFCA18',
  questions: ['Wie lehrreich war der Beitrag?', 'Wie unterhaltsam war er?', 'Wie gefällt Ihnen die Gestaltung?'],
  title: 'Wie bewerten Sie diesen Beitrag?',
  answerText: 'Die meisten Leserinnen und Leser bewerten den Beitrag als sehr gut. Das freut uns.'
};
var _default = UserFeedback;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-user-feedback/dist/index.js
// module id = 449
// module chunks = 0